export default __webpack_public_path__ + "static/media/al.3328d68f.svg";